import { StaffGate } from "../components/StaffGate";
import { PosApp } from "../components/PosApp";

export function HomePage() {
  return (
    <StaffGate>
      {({ device, staff, unpairDevice, signOut, clockedIn, clockingIn, clockIn, clockOut, shiftError }) => (
        <PosApp
          device={device}
          staff={staff}
          onSignOut={signOut}
          onUnpairDevice={unpairDevice}
          clockedIn={clockedIn}
          clockingIn={clockingIn}
          onClockIn={clockIn}
          onClockOut={clockOut}
          shiftError={shiftError}
        />
      )}
    </StaffGate>
  );
}
